'server-only'

import { createSearchParamsCache, createSerializer } from 'nuqs/server'
import { queryStringParsers } from '~/schemas/qs_parsers'

export const qs = createSearchParamsCache(queryStringParsers)
export const activeQS = createSerializer(queryStringParsers)
export const formatQS = (value: string) => decodeURIComponent(value)
